import React, { useContext, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom';
import UserContext, { UserProvider } from './context/user.jsx';

import SignInPage from './pages/sign_in.jsx';
import Dashboard from './pages/dashboard.jsx';
import DashboardHome from './pages/dashboard_home.jsx';
import DashboardFileManager from './pages/dashboard_file_manager.jsx';
import Backup from './pages/backup.jsx';
import CAF from './pages/caf.jsx';
import { ModalsProvider } from './context/modals.jsx';

const Index = () => {
	const navigate = useNavigate();
	const user_context = useContext(UserContext);

	useEffect(() => {
		if (!user_context.loaded) return;
		
		if (!user_context.user) {
			navigate('/sign_in');
		} else {
			navigate('/dashboard');
		}
	}, [user_context.loaded, user_context.user, navigate]);

	if (!user_context.loaded) return <p>Loading...</p>;

	return null;
};

export default function App() {
	return (
		<Router>
			<ModalsProvider>
				<UserProvider>
					<Routes>
						<Route exact path="/" element={<Index element />} />
						<Route path="/sign_in" element={<SignInPage />} />
						<Route path="/dashboard" element={<Dashboard />}>
							<Route path="" element={<DashboardHome />} />
							<Route path=":app_uid/" element={<CAF />} />
							<Route path="backup" element={<Backup />} />
							<Route path=":app_uid/file_manager" element={<DashboardFileManager />} />
						</Route>
					</Routes>
				</UserProvider>
			</ModalsProvider>
		</Router>
	);
}
